import $ from 'jquery';
import 'slick-carousel';

$(function () {
	$('.front-works-list').slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				variableWidth: true,
				centerMode: true
			}
		}]
	});
});